// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductSearchModal_root__DKyEe","modal":"ProductSearchModal_modal__aHKx3","inputBtn":"ProductSearchModal_inputBtn__UJ6g1"};